import * as Immutable from 'immutable';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import PatternBrowser, { Props } from '../_components/PatternBrowser';
import { OnPatternDesignServiceOffsetChange, OnSelectCategory } from '../../_actions/PatternActions';

const mapStateToProps = (store:Immutable.Record<any>, props: Props) => ({
	loading: store.getIn(['UIData', 'loaders', 'patterns']),
	offset: store.getIn(['patternDesignService', 'offset']),
	patterns: store.getIn(['patternDesignService','patterns']),
	selectedCategoryId: store.getIn(['patternDesignService', 'selectedCategoryId'])
});

const mapDispatchToProps = (dispatch:Dispatch, props:Props) => ({
	onSetOffset: (offset:number) => dispatch(OnPatternDesignServiceOffsetChange(offset)),
	onSelectCategory: (id:string) => dispatch(OnSelectCategory(id)),
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(PatternBrowser);